/**
 * Main App Component
 * Root application component with providers and routing
 */
import React from 'react';

import AppProviders from './providers/AppProviders';
import AppRoutes from './routes/AppRoutes';

/**
 * App Component
 * @returns {JSX.Element} Application root
 */
const App = () => {
  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
};

export default App;
